import { render, staticRenderFns } from "./RestaurantTabView.vue?vue&type=template&id=01edb840&scoped=true&"
import script from "./RestaurantTabView.vue?vue&type=script&lang=js&"
export * from "./RestaurantTabView.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantTabView.vue?vue&type=style&index=0&id=01edb840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01edb840",
  null
  
)

export default component.exports